import styled from 'styled-components';

import { UiTypography } from '@/components/ui/Typography';
import { OnboardingPage } from '@/pages/Onboarding/components/Page';

export const PageStyles = styled(OnboardingPage)`
  ion-content {
    background: url('/assets/layout-own-ai-man/pride/g12.png') center/cover
      no-repeat;
    &::part(scroll) {
      display: flex;
      justify-content: center;
      align-items: stretch;
      height: 100%;
    }

    .content-wrapper {
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      padding: 48px 16px 24px;
      display: flex;
      flex-direction: column;
      align-items: center;
      backdrop-filter: blur(3px);
    }

    .app-logo {
      margin-bottom: 20px;
    }

    .page-title {
      margin-bottom: 20px;
    }

    .loading-wrapper {
      width: 90%;
    }
  }

  #root .ion-page & {
    ion-footer {
      padding: 16px 16px 32px;

      .page-footer-button {
        font-size: 14px;
        font-weight: 600;
        line-height: 20px;
        border-radius: 12px;
      }
    }
  }
`;

export const PageTitleStyles = styled(UiTypography)`
  .ion-page & {
    font-weight: 600;
  }
`;
